import { useState } from 'react';
import * as bi from 'react-bootstrap-icons';
import { IClientTripFull, IClientTripFullPoint } from '@bustickus/models-client';
import { Button, Flex } from 'components';
import { reverseArray } from 'common/helpers';
import { PointList } from 'shared/components';
import { IPointListPoint } from 'shared/types';
import './style.scss';

interface IProps {
  trip: IClientTripFull;
  departureCityId: string | null | undefined;
  arrivalCityId: string | null | undefined;
}

function TripPath(props: IProps) {
  const [open, setOpen] = useState<boolean>(false);

  const getPathPointsArray = (): IPointListPoint[] => {
    const result: IPointListPoint[] = [];

    if (!open) {
      const dPoint =
        props.trip.points.find((x: IClientTripFullPoint) => x.cityId == props.departureCityId) ?? props.trip.points[0];
      const aPoint =
        reverseArray(props.trip.points).find((x: IClientTripFullPoint) => x.cityId == props.arrivalCityId) ??
        props.trip.points[props.trip.points.length - 1];

      result.push(modelPointToListPoint({ ...dPoint, arrivalDate: undefined }));
      result.push(modelPointToListPoint({ ...aPoint, departureDate: undefined }));
    } else {
      for (let i = 0; i < props.trip.points.length; i++) {
        const point = props.trip.points[i];
        result.push(modelPointToListPoint(point));
      }
    }

    return result;
  };

  return (
    <Flex
      direction='column'
      className='trip-path-short-75T2'
      gap={20}
    >
      <PointList points={getPathPointsArray()} />

      {props.trip.points.length > 2 && (
        <Button
          color='transparent-blue'
          size='small'
          onClick={() => setOpen(!open)}
        >
          {!open && (
            <Flex
              justifyContent='center'
              alignItems='center'
              gap={5}
            >
              <bi.ChevronDown />
              <span>Полный маршрут</span>
            </Flex>
          )}
          {open && (
            <Flex
              justifyContent='center'
              alignItems='center'
              gap={5}
            >
              <bi.ChevronUp />
              <span>Свернуть</span>
            </Flex>
          )}
        </Button>
      )}
    </Flex>
  );
}

function modelPointToListPoint(model: IClientTripFullPoint): IPointListPoint {
  return {
    cityName: model.cityName,
    countryName: model.country?.name,
    address: model.address,
    departureDate: model.departureDate,
    arrivalDate: model.arrivalDate,
  };
}

export default TripPath;
